<template>
  <div>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap justify-center>
                <v-flex xs12 sm6 md3>
                  <v-icon >{{ form.icon }}</v-icon>
                  <text-input
                    :form="form"
                    label="Icono"
                    :v-errors="errors"
                    v-model="form.icon"
                    :value.sync="form.icon"
                    name="icon"
                    ></text-input>
                    <!-- v-validate="'required'" -->
                  <text-input
                    :form="form"
                    label="Concepto"
                    :v-errors="errors"
                    :value.sync="form.description"
                    name="description"
                    v-validate="'required'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    ref="cost"
                    :form="form"
                    label="Valor"
                    :v-errors="errors"
                    :value.sync="form.cost"
                    name="cost"
                    v-validate="'required'"
                    v-model="form.cost"
                    @keypress="onlyNumbers"
                    prefix="$"
                    v-money="money"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md1>
                  <check-input
                    :form="form"
                    label="Activo"
                    :v-errors="errors"
                    :value.sync="form.status"
                    name="status"
                    v-validate="'required'"
                  ></check-input>
                </v-flex>
                <v-flex xs12 sm3 md1>
                  <v-btn v-if="!editing" color="primary" @click="saveAllyCost">Guardar</v-btn>
                  <v-btn v-else color="secondary" @click="updateAllyCost">Actualizar</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="allyCosts"
          class="elevation-1 mt-3"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.description }}</td>
            <td class="text-xs-center">${{ formatNumber(props.item.cost) }}</td>
            <td class="text-xs-center">{{ props.item.status == 1 ? 'Si' : 'No' }}</td>
            <td class="text-xs-center">
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="editAllyCost(props.item)"
                  slot="activator"
                >
                  edit
                </v-icon>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="deleteAllyCost(props.item.id)"
                  slot="activator"
                >
                  delete
                </v-icon>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import axios from 'axios';
  import Form from 'vform';
  import { VMoney } from 'v-money';
  export default {
    name: 'enrollment-allies-costs-modal',
    props: {
      ally: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        form: new Form({
            enrollment_allies_id: '',
            description: '',
            icon: '',
            cost: 0,
            required: false,
            status: true,
        }),
        headers: [
          // { text: 'Icono', align: 'center', value: 'icon' },
          { text: 'Concepto', align: 'center', value: 'description' },
          { text: 'Valor', align: 'center', value: 'cost' },
          { text: 'Activo', align: 'center', value: 'status' },
          { text: 'Acciones', align: 'center', value: 'acciones' }
        ],
        allyCosts: [],
        editing: false,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
      }
    },
    directives: {money: VMoney},
    watch: {
      ally: {
        handler(newValue, oldValue) {
          if (newValue.id && newValue.id !== oldValue.id) {
            this.form.enrollment_allies_id = newValue.id;
            this.init();
          }
          if (newValue.icon !== oldValue.icon) {
            this.form.icon = newValue.icon;
          }
        },
        deep: true
      }
    },
    methods: {
      init() {
        axios.get(`/api/enrollments/allyCosts/${this.ally.id}`)
          .then((resp) => {
            if (resp.status === 200) {
              this.allyCosts = resp.data
            }
          })
      },
      async saveAllyCost() {
        if (await this.formHasErrors()) return

        axios.post('/api/enrollments/allyCosts', this.form)
          .then((resp) => {
            if (resp.status === 200) {
              this.init();
              this.clearForm();
            }
          })
      },
      async updateAllyCost() {
        if (await this.formHasErrors()) return

        axios.put('/api/enrollments/allyCosts', this.form)
          .then((resp) => {
            if (resp.status === 200) {
              this.init();
              this.editing = false,
              this.clearForm();
            }
          })
      },
      editAllyCost(allyCost) {
        this.form = new Form({
          id: allyCost.id,
          enrollment_allies_id: allyCost.enrollment_allies_id,
          description: allyCost.description,
          description: allyCost.icon,
          cost: allyCost.cost,
          required: allyCost.required == 1,
          status: allyCost.status == 1,
        });
        this.$refs.cost.$el.getElementsByTagName('input')[0].value = allyCost.cost;
        this.editing = true;
      },
      deleteAllyCost(id) {
        axios.delete(`/api/enrollments/allyCosts/${id}`)
          .then((resp) => {
            if (resp.status === 200) {
              this.init();
            }
          })
      },
      onlyNumbers($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if(keyCode == 45) { //This is a code por - (minus sign)
            $event.preventDefault();
        }
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      clearForm() {
        const actual_enrollment_allies_id = this.form.enrollment_allies_id
        this.form = new Form({
          enrollment_allies_id: actual_enrollment_allies_id,
          description: '',
          icon: '',
          cost: 0,
          required: false,
          status: true,
        });
        this.$refs.cost.$el.getElementsByTagName('input')[0].value = 0;
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/allies_costs.vue